import React, { useCallback, useContext, useEffect, useState } from 'react'

import { useDropzone } from 'react-dropzone'
import { FaTrashAlt } from 'react-icons/fa'
import Context from '../../context'

import ImageUploadToS3 from '../../services/ImageUpload'

function ImagesDragDrop() {
  const { setImageList, newImageList, setNewImageList, imageList } = useContext(Context)
  const [updatedList, setUpdatedList] = useState(false)

  const onDrop = useCallback(
    acceptedFiles => {
      const images = [...newImageList]
      setUpdatedList(false)

      if (acceptedFiles && acceptedFiles.length > 0) {
        acceptedFiles.forEach(image => {
          const reader = new FileReader()
          images.push({ image, logoPath: null, sended: false })

          reader.readAsDataURL(image)
        })
      }
      setNewImageList([...images])
      setUpdatedList(true)
    },
    [newImageList]
  )

  useEffect(() => {
    const sendToS3 = async () => {
      const res = await newImageList.map(async item => {
        if (!item.sended) {
          const { image } = item
          const logoPath = await ImageUploadToS3(image)

          return { image: null, logoPath, sended: true }
        }
        return item
      })

      return Promise.all(res)
    }
    if (updatedList && newImageList.length > 0) {
      sendToS3().then(list => {
        setNewImageList([...list])
        setImageList(list)
      })
    }
  }, [updatedList])

  const maxSize = 5242880

  const { getRootProps, getInputProps, isDragActive, isDragReject, rejectedFiles } = useDropzone({
    onDrop,
    accept: 'image/png, image/jpeg, image/jpg',
    minSize: 0,
    maxSize
  })

  const handleRemoveImage = image => {
    const newArr = newImageList.filter(item => {
      return item !== image
    })

    setNewImageList(newArr)

    const newArrUpdate = imageList.filter(item => {
      return item !== image
    })

    setImageList(newArrUpdate)
  }

  const isFileTooLarge = rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize

  return (
    <div className="row">
      <h4 className="col-12 text-center clube-20-botom-margin">Enviar Imagens</h4>
      <p className="text-center w-100">
        * As imagens passarão pela aprovação da equipe do Clube Gazeta do Povo
      </p>
      <div className="container text-center">
        <div
          className="drag-area align-items-center justify-content-center d-flex clube-20-botom-margin"
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          {!isDragActive && 'Arraste e solte as imagens aqui, ou clique para buscar.'}
          {isDragActive && !isDragReject && 'Solte para enviar.'}
          {isDragReject && 'Desculpe, este tipo de arquivo não é surportado.'}
          {isFileTooLarge && <div className="text-danger mt-2">A imagem é muito grande.</div>}
        </div>
        <div className="row">
          {newImageList.length > 0 &&
            newImageList.map((newImage, index) => (
              <div
                key={
                  newImage.image !== null ? `${newImage.image.name}-${index}` : newImage.logoPath
                }
                className="col-3"
                style={{ padding: 10 }}
              >
                <div className="card">
                  <img
                    src={
                      newImage.image !== null
                        ? URL.createObjectURL(newImage.image)
                        : `${process.env.REACT_APP_IMAGES_URL}${newImage.logoPath}`
                    }
                    className="card-img-top"
                    alt="..."
                  />
                  {newImage.sended && (
                    <div
                      className="d-flex flex-row justify-content-end align-content-end"
                      style={{ margin: '5px' }}
                    >
                      <button
                        className=" btn btn-danger "
                        type="button"
                        onClick={() => handleRemoveImage(newImage)}
                        data-toggle="modal"
                        data-target="#deleteModal"
                        style={{ marginLeft: -5 }}
                      >
                        <FaTrashAlt />
                      </button>
                    </div>
                  )}
                  {!newImage.sended && (
                    <div className="card-body">
                      <div className="progress">
                        <div
                          aria-label="progress"
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          style={{ width: '100%', marginTop: '5px' }}
                          aria-valuenow="100"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default ImagesDragDrop
